import { Component, inject } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-case-spelling-dialog',
  standalone: false,
  templateUrl: './case-spelling-dialog.component.html'
})
export class CaseSpellingDialogComponent {
  private ref = inject(DynamicDialogRef)

  ok() {
    this.ref.close(true)
  }

  cancel() {
    this.ref.close(false)
  }
}
